import { useEffect } from 'react';
import { Platform } from 'react-native';
import { LoginRedirect } from '../components/LoginRedirect';
import { ROUTES } from '../utils/constants';
import { sanitizeRedirectUrl } from '../utils/redirect';

// Capture before Expo Router potentially rewrites window.location. RN
// polyfills `window` (typeof check passes) but not `window.location`, so
// checking Platform.OS avoids crashing at module load on Android when the
// screen is imported transitively via `src/index.ts`. The extra
// `typeof window` check keeps the module safe under Node prerender/SSR
// (where Platform.OS is also 'web' but `window` is undefined).
const canReadLocation = Platform.OS === 'web' && typeof window !== 'undefined';
const initialSearch = canReadLocation ? window.location.search : '';

export default function NotFoundScreen() {
  useEffect(() => {
    if (!canReadLocation) return;
    const params = new URLSearchParams(initialSearch);
    const next = params.get('next');
    if (next) {
      const sanitized = sanitizeRedirectUrl(next, '');
      window.location.replace(sanitized ? `${ROUTES.LOGIN}?next=${encodeURIComponent(sanitized)}` : ROUTES.LOGIN);
    }
  }, []);

  return <LoginRedirect href={ROUTES.LOGIN} />;
}
